import { memo } from "react";
import { useNavigate } from "react-router-dom";
import { SupportSheet } from "../../components/SupportSheet";
import { FUND_REQUEST_ROUTES } from "../../constants";
import { TransactionsPage } from "./TransactionsPage";

export const SupportPage = memo(() => {
  const navigate = useNavigate();

  return (
    <>
      <TransactionsPage />
      <SupportSheet
        namespace="fund-request"
        visible
        onClose={() => navigate(FUND_REQUEST_ROUTES.TRANSACTIONS)}
      />
    </>
  );
});
